module.exports = __webpack_public_path__ + "static/media/cnh-back.7141fd26.jpg";